var _path, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
var SvgCloudUpload2 = function SvgCloudUpload2(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    ref: ref
  }, props), /*#__PURE__*/React.createElement("mask", {
    id: "cloud_upload2_svg__a",
    width: 24,
    height: 24,
    x: 0,
    y: 0,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "alpha"
    }
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#D9D9D9",
    d: "M0 0h24v24H0z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#cloud_upload2_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#414A5F",
    d: "m11.25 12.215-1.333 1.318a.7.7 0 0 1-.513.207.73.73 0 0 1-.531-.223.68.68 0 0 1-.212-.526.73.73 0 0 1 .212-.527l2.494-2.495A.87.87 0 0 1 12 9.698q.361 0 .633.271l2.494 2.495a.75.75 0 0 1 .22.518.68.68 0 0 1-.22.536.72.72 0 0 1-.52.21.75.75 0 0 1-.534-.205l-1.323-1.308v5.477q0 .116.096.212a.3.3 0 0 0 .212.096H18.5q1.05 0 1.775-.725T21 15.5t-.725-1.775T18.5 13H17v-2q0-2.075-1.463-3.537Q14.075 6 12 6 9.925 6 8.463 7.463 7 8.925 7 11h-.52q-1.42 0-2.45 1.025A3.36 3.36 0 0 0 3 14.5q0 1.45 1.025 2.475A3.37 3.37 0 0 0 6.5 18h1.75q.319 0 .534.216A.73.73 0 0 1 9 18.75q0 .32-.216.535a.73.73 0 0 1-.534.215H6.5q-2.072 0-3.536-1.438Q1.5 16.623 1.5 14.546q0-1.863 1.199-3.278 1.199-1.414 2.974-1.676.48-2.242 2.255-3.667T12 4.5q2.716 0 4.608 1.892T18.5 11v.5h.308q1.58.123 2.636 1.271Q22.5 13.92 22.5 15.5q0 1.672-1.154 2.837Q20.192 19.5 18.52 19.5h-5.461q-.758 0-1.283-.525a1.75 1.75 0 0 1-.525-1.283z"
  }))));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgCloudUpload2);
export default ForwardRef;